(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('anomaly-category', {
            parent: 'company_admin',
            url: '/anomaly-category?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.anomalyCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/anomaly-category/anomaly-categories.html',
                    controller: 'AnomalyCategoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('anomalyCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('anomaly-category-detail', {
            parent: 'anomaly-category',
            url: '/anomaly-category/{id}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.anomalyCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/anomaly-category/anomaly-category-detail.html',
                    controller: 'AnomalyCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('anomalyCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AnomalyCategory', function($stateParams, AnomalyCategory) {
                    return AnomalyCategory.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'anomaly-category',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('anomaly-category-detail.edit', {
            parent: 'anomaly-category-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/anomaly-category/anomaly-category-dialog.html',
                    controller: 'AnomalyCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AnomalyCategory', function(AnomalyCategory) {
                            return AnomalyCategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('anomaly-category.new', {
            parent: 'anomaly-category',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/anomaly-category/anomaly-category-dialog.html',
                    controller: 'AnomalyCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('anomaly-category', null, { reload: 'anomaly-category' });
                }, function() {
                    $state.go('anomaly-category');
                });
            }]
        })
        .state('anomaly-category.edit', {
            parent: 'anomaly-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/anomaly-category/anomaly-category-dialog.html',
                    controller: 'AnomalyCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AnomalyCategory', function(AnomalyCategory) {
                            return AnomalyCategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('anomaly-category', null, { reload: 'anomaly-category' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('anomaly-category.delete', {
            parent: 'anomaly-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/anomaly-category/anomaly-category-delete-dialog.html',
                    controller: 'AnomalyCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AnomalyCategory', function(AnomalyCategory) {
                            return AnomalyCategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('anomaly-category', null, { reload: 'anomaly-category' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
